import { connect } from 'react-redux';
import { WithRouterProps } from 'react-router';
import { Dispatch } from 'redux';
import { trackBrandClick } from '../../actions/eventAnalytics';
import { getAppLocale } from '../../selectors/app';
import { getIsPaymentView } from '../../selectors/routing';
import { CheckoutState } from '../../state';
import { getCheckoutStepFromPath } from '../../utils/analytics';
import type { PoweredByEventbriteTextProps } from './PoweredByEventbriteText';

type ConnectedPropsFromState = Pick<
    PoweredByEventbriteTextProps,
    'locale' | 'isCheckoutForm'
>;

const mapStateToProps = (state: CheckoutState): ConnectedPropsFromState => ({
    locale: getAppLocale(state),
    isCheckoutForm: getIsPaymentView(state),
});

type ConnectedPropsFromDispatch = Pick<PoweredByEventbriteTextProps, 'onClick'>;

const mapDispatchToProps = (
    dispatch: Dispatch<CheckoutState>,
    { location }: WithRouterProps,
): ConnectedPropsFromDispatch => ({
    onClick: () =>
        dispatch(trackBrandClick(getCheckoutStepFromPath(location.pathname))),
});

export type ConnectedProps = Omit<
    PoweredByEventbriteTextProps,
    keyof ConnectedPropsFromState & keyof ConnectedPropsFromDispatch
>;

export default connect(mapStateToProps, mapDispatchToProps);
